(function () {
  'use strict';

  angular
      .module('tfc.Help')
      .factory('Help', Help);

  // @ngInject
  function Help(Api) {

    return {
      send : send
    };

    function send(subject, message) {
      return Api.post('/help', {
        subject : subject,
        message : message
      });
    }
  }

})();
